export default __webpack_public_path__ + "static/media/E9Arendering.fed30d7d.jpeg";